import React, { Component } from 'react'

class CollectionsInfo extends Component<any, any> {
    render() {
        const { categories, servicefields } = this.props
        return (
            <div>
                {servicefields && servicefields.length > 0 ? (
                    <div>
                        <strong>תחומי שירות</strong>
                        {servicefields.map((spec, index) => (
                            <div key={index}>- {spec.name}</div>
                        ))}
                    </div>
                ) : (
                    <div>
                        <strong>ללא תחומי שירות</strong>
                    </div>
                )}
                {categories && categories.length > 0 ? (
                    <div>
                        <strong>קטגוריות</strong>
                        {categories.map((spec, index) => (
                            <div key={index}>- {spec.name}</div>
                        ))}
                    </div>
                ) : (
                    <div>
                        <strong>ללא קטגוריות</strong>
                    </div>
                )}
            </div>
        )
    }
}

export default CollectionsInfo
